import * as React from "react"

const NavigationList = props => (
  <>
    <ul className="ul-footer">{props.children}</ul>
  </>
)

export default NavigationList
